import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { DropdownToggle } from "./DropdownToggle/DropdownToggle";
import { DropdownMenu } from "./DropdownMenu/DropdownMenu";

import "./Dropdown.scss";

export class Dropdown extends React.Component {
  static defaultProps = {
    openOnHover: false,
  };

  static propTypes = {
    /** Children to be rendered */
    children: PropTypes.node,
    /** A function to be called everytime the dropdown is toggled */
    onToggle: PropTypes.func,
    /** A boolean to determine if the dropdown should open on hover */
    openOnHover: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.fieldRef = React.createRef();
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  toggleIsOpen = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const { isOpen } = this.state;

    const newIsOpen = !isOpen;

    this.setIsOpen(newIsOpen);
  };

  handleClickOutside = (event) => {
    if (this.fieldRef && !this.fieldRef.current.contains(event.target)) {
      this.setIsOpen(false);
    }
  };

  setIsOpen = (newIsOpen) => {
    const { onToggle } = this.props;

    if (newIsOpen) {
      document.addEventListener("mousedown", this.handleClickOutside);
    } else {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }

    if (onToggle) {
      onToggle(newIsOpen);
    }

    this.setState({ isOpen: newIsOpen });
  };

  render() {
    const { isOpen } = this.state;
    const { children, openOnHover } = this.props;

    const eventProps = {};

    const dropdownToggle = React.Children.map(children, (child) => {
      if (child.type === DropdownToggle) {
        const dropdownToggleClass = classNames({
          "DropdownToggle--open": isOpen,
        });
        return React.cloneElement(child, {
          toggleIsOpen: this.toggleIsOpen,
          className: dropdownToggleClass,
        });
      }
      return null;
    });

    const dropdownMenu = React.Children.map(children, (child) => {
      if (child.type === DropdownMenu) {
        return React.cloneElement(child, { isOpen, setIsOpen: this.setIsOpen });
      }
      return null;
    });

    if (openOnHover) {
      eventProps.onMouseEnter = this.toggleIsOpen;
      eventProps.onMouseLeave = this.toggleIsOpen;
    }

    return (
      <div ref={this.fieldRef} {...eventProps} className="Dropdown">
        {dropdownToggle}
        {dropdownMenu}
      </div>
    );
  }
}

export default Dropdown;
